var slideIndex = 0;
var slides = document.getElementsByClassName("review-slide");
var slideInterval = 3000; // Time duration between slide transitions (in milliseconds)
var slideTimer;
var isSliderPaused = false; // Variable to track if the slider is currently paused

showSlides();
startSlideInterval();

function showSlides() {
  var numSlidesToShow = 1; // Number of slides to show based on device

  if (window.innerWidth >= 769) {
    numSlidesToShow = 3; // Show 4 slides on desktop
  }

  for (var i = 0; i < slides.length; i++) {
    if (i >= slideIndex && i < slideIndex + numSlidesToShow) {
      slides[i].style.display = "flex";
    } else {
      slides[i].style.display = "none";
    }
  }
}

function prevSlide() {
  if (slideIndex > 0) {
    slideIndex--;
  }
  showSlides();
}

function nextSlide() {
  if (slideIndex < slides.length - 4) {
    slideIndex++;
  } else {
    slideIndex = 0; // Reset slide index to start from the first slide
  }
  showSlides();
}

function startSlideInterval() {
  slideTimer = setInterval(function() {
    if (!isHovered() && !isSliderPaused) {
      nextSlide();
    }
  }, slideInterval);
}

function stopSlideInterval() {
  clearInterval(slideTimer);
}

// Check if any slide is currently being hovered
function isHovered() {
  for (var i = 0; i < slides.length; i++) {
    if (slides[i].matches(":hover")) {
      return true;
    }
  }
  return false;
}

// Pause slide interval when hovering over a slide
for (var i = 0; i < slides.length; i++) {
  slides[i].addEventListener("mouseenter", function() {
    stopSlideInterval();
  });

  slides[i].addEventListener("mouseleave", function() {
    startSlideInterval();
  });
}

// Toggle slider pause on "Read More" and "Read Less" button clicks
function toggleDescription(button) {
  var description = button.parentNode.getElementsByClassName("full-description")[0];
  var shortDescription = button.parentNode.getElementsByClassName("short-description")[0];

  if (description.style.display === "none") {
    description.style.display = "block";
    shortDescription.style.display = "none";
    button.textContent = "Read Less";
    isSliderPaused = true;
  } else {
    description.style.display = "none";
    shortDescription.style.display = "block";
    button.textContent = "Read More";
    isSliderPaused = false;
  }
}

// Re-adjust slide display on window resize
window.addEventListener("resize", showSlides);
